import { useEffect } from 'react';

// What the browser tab says.
//
// navConfig has claimed since it was written that "the document title reads
// from this", and nothing set document.title at all — every screen in the
// product, and the public homepage, was titled "TopoSDS Admin". That is
// what a crawler indexes for toposds.com, and what somebody sees when they
// have eight tabs open and one of them is this.

export const SITE_NAME = 'TopoSDS';

export default function useDocumentTitle(title?: string | null): void {
  useEffect(() => {
    const previous = document.title;
    document.title = title
      ? `${title} · ${SITE_NAME}`
      : `${SITE_NAME} — Operations for delivery contractors`;
    // Restored on unmount so a screen that sets a title cannot leave it
    // behind on the one you navigate to next.
    return () => { document.title = previous; };
  }, [title]);
}
